<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2 *ngIf="this.status === 'create'">Add Customer</h2>
  <h2 *ngIf="this.status === 'edit'">Edit Customer</h2>
</div>


<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="renterDetails">
    <nz-card>
      <div>
        <h5 class="text-primary">Renter's Details</h5>

        <form nz-form [formGroup]="customerForm">
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-2">
            <div class="grid sm:grid-cols-1" formGroupName="renterDetails">

              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="fullName" nzRequired>Full Name</nz-form-label>
                <nz-form-control [nzErrorTip]="fullName">
                  <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                    <ng-template #addOnBeforeTemplate>
                      <nz-select formControlName="title" class="surname-select" nzPlaceHolder="Select" >
                        <nz-option nzLabel="Mr." nzValue="MR"></nz-option>
                        <nz-option nzLabel="Mrs." nzValue="MRS"></nz-option>
                        <nz-option nzLabel="Miss." nzValue="MISS"></nz-option>
                      </nz-select>
                    </ng-template>
                    <input nz-input type="text" [maxLength]="70" formControlName="fullName" placeHolder="Enter Full Name"/>
                  </nz-input-group>
                </nz-form-control>
                <ng-template #fullName>
                <span
                  *ngIf="customerForm.get('renterDetails.fullName').hasError('required')">Please enter Customer Name</span>
                  <span *ngIf="customerForm.get('renterDetails.fullName').hasError('maxlength')">
                  Maximum length is 70 characters</span>
                  <span *ngIf="customerForm.get('renterDetails.fullName').hasError('pattern')">
                  Only allowed letters, please avoid adding special characters or numbers</span>
                </ng-template>
              </nz-form-item>
            </div>


            <div class="grid sm:grid-cols-1 gap-2" formGroupName="renterDetails">

              <nz-form-item class="grid grid-flow-row content-start"
                            [ngClass]="{'has-error': customerForm.get('renterDetails.contactNo').invalid && customerForm.get('renterDetails.contactNo').touched}">
                <nz-form-label nzFor="contactNo" nzRequired>Contact Number (Home Country)</nz-form-label>
                <nz-form-control [nzErrorTip]="mobileNo">

                  <nz-input-group [nzAddOnBefore]="addOnBeforeDailCodeTemplate">
                    <ng-template #addOnBeforeDailCodeTemplate>
                      <nz-select formControlName="dailCode" class="country-code-select" nzPlaceHolder="Select"
                                 (nzOnSearch)="onSearchDailCode($event)" nzAllowClear nzShowSearch >
                        <nz-option *ngFor="let data of this.filteredCountryDailCodeData" nzValue="{{data.code}}" nzLabel="{{data.dial_code}}"></nz-option>
                      </nz-select>
                    </ng-template>
                    <input nz-input type="text" formControlName="contactNo" [maxLength]="15"
                           placeHolder="Enter Mobile Number"/>
                  </nz-input-group>
                </nz-form-control>
                <ng-template #mobileNo>
                  <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('required')">Please Enter Mobile Number</span>
                  <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('maxlength')"> Maximum length is 15 characters</span>
                  <span *ngIf="customerForm.get('renterDetails.contactNo').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                </ng-template>
              </nz-form-item>
            </div>

           <div  formGroupName="renterDetails">
             <nz-form-item class="grid grid-flow-row content-start"
                           [ngClass]="{'has-error': customerForm.get('renterDetails.email').invalid && customerForm.get('renterDetails.email').touched || this.emailExists}">
               <nz-form-label nzFor="email">Email</nz-form-label>
               <nz-form-control [nzErrorTip]="email">
                 <input nz-input type="text" formControlName="email"
                        placeHolder="Enter email"/>
               </nz-form-control>
               <ng-template #email>
                 <span *ngIf="customerForm.get('renterDetails.email').hasError('required')">Please Enter Email</span>
                 <span *ngIf="customerForm.get('renterDetails.email').hasError('pattern')">Only allowed numbers, please avoid adding special characters or letters</span>
                 <span *ngIf="customerForm.get('renterDetails.email').hasError('email')&& customerForm.get('renterDetails.email').touched">Invalid email address, please review your input.</span>
                 <span *ngIf="this.emailExists">Email address already exists. Select another email.</span>
               </ng-template>
             </nz-form-item>
           </div>
          </div>

          <div class=" grid md:grid-cols-1 xl:grid-cols-2 gap-2">
            <div class="grid sm:grid-cols-1" formGroupName="renterDetails">
              <div>
                <label class="mt-2">Home Address</label>
                <nz-form-item class="mt-2">
                  <nz-form-control>
                    <nz-textarea-count [nzMaxCharacterCount]="300">
                <textarea rows="2" nz-input formControlName="homeAddress"
                          PlaceHolder="Home Address"></textarea>
                    </nz-textarea-count>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <div class="grid  md:grid-cols-1 lg:grid-cols-2 gap-2" formGroupName="renterDetails">


              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="homeCountry" nzRequired>Home Country</nz-form-label>
                <nz-form-control [nzErrorTip]="homeCountry">
                  <nz-select nzAllowClear nzShowSearch (nzOnSearch)="onSearchHomeCountry($event)" formControlName="homeCountry" nzRequired nzPlaceHolder="Select">
                    <nz-option *ngFor="let data of this.filteredCountryData" nzValue="{{data.name}}" nzLabel="{{data.name}}"></nz-option>

                  </nz-select>
                </nz-form-control>
                <ng-template #homeCountry>
                  <span
                    *ngIf="formErrors.renterDetails.homeCountry.required">Please Enter Home Country </span>
                </ng-template>
              </nz-form-item>

              <nz-form-item class="grid grid-flow-row content-start" *ngIf="this.customerForm.get('renterDetails.homeCountry').value === 'Other'">
                <nz-form-label nzFor="otherCountry">Other Country</nz-form-label>
                <nz-form-control>
                  <input nz-input type="text" [maxLength]="70" formControlName="otherCountry" placeHolder="Other Country"/>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="grid md:grid-cols-1 xl:grid-cols-4 gap-2" formGroupName="renterDetails">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="dob" >Date of Birth</nz-form-label>
              <nz-form-control [nzErrorTip]="dob">
                <nz-date-picker formControlName="dob"
                                class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #dob>
        <span
          *ngIf="formErrors.renterDetails.dob.required">Please Enter Date of Birth </span>
              </ng-template>
            </nz-form-item>


            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="birthCity" >Birth City</nz-form-label>
              <nz-form-control>
                <input nz-input type="text" [maxLength]="70" formControlName="birthCity" placeHolder="Birth City"/>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="birthCountry" >Birth Country</nz-form-label>
              <nz-select nzAllowClear nzShowSearch (nzOnSearch)="onSearchBirthCountry($event)" formControlName="birthCountry" nzRequired nzPlaceHolder="Select">
                <nz-option *ngFor="let data of this.filteredBirthCountryData" nzValue="{{data.name}}" nzLabel="{{data.name}}"></nz-option>
              </nz-select>
            </nz-form-item>

          </div>
        </form>
      </div>
    </nz-card>
  </section>


  <section id="passportLicenceDetails" class="mt-8">
    <nz-card>
      <div>
        <h5 class="text-primary">Passport/Licence Details</h5>

        <form nz-form [formGroup]="customerForm">
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-4 gap-2" formGroupName="passportLicenceDetails">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="passportNo">Passport Number</nz-form-label>
              <nz-form-control [nzErrorTip]="PassNo">
                <input nz-input type="text" [maxLength]="70" (input)="checkExisting($event)" formControlName="passportNo" placeHolder="Passport Number"/>
              </nz-form-control>
              <ng-template #PassNo>
        <span
          *ngIf="passExists">Passport number already exists </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="issueDatePass">Issued Date</nz-form-label>
              <nz-form-control [nzErrorTip]="issueDatePass">
                <nz-date-picker formControlName="issueDatePass"
                                class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #issueDatePass>
        <span
          *ngIf="formErrors.passportLicenceDetails.issueDatePass.required">Please Enter Passport Issued Date </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="expiryDatePass">Expiry Date</nz-form-label>
              <nz-form-control [nzErrorTip]="expiryDatePass">
                <nz-date-picker formControlName="expiryDatePass" [nzDisabledDate]="pastDateDisabled"
                                class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #expiryDatePass>
        <span
          *ngIf="formErrors.passportLicenceDetails.expiryDatePass.required">Please Passport Expiry Date </span>
              </ng-template>
            </nz-form-item>


          </div>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-4 gap-2" formGroupName="passportLicenceDetails">

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="drivingLicenceNo" >Driving Licence Number</nz-form-label>
              <nz-form-control>
                <input nz-input type="text" [maxLength]="70" formControlName="drivingLicenceNo" placeHolder="Driving Licence Number"/>
              </nz-form-control>
            </nz-form-item>


            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="issueDateLicence">Issued Date</nz-form-label>
              <nz-form-control [nzErrorTip]="issueDateLicence">
                <nz-date-picker formControlName="issueDateLicence"
                                class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #issueDateLicence>
        <span
          *ngIf="formErrors.passportLicenceDetails.issueDateLicence.required">Please Enter Licence Issued Date </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="expiryDateLicence">Expiry Date</nz-form-label>
              <nz-form-control [nzErrorTip]="expiryDateLicence">
                <nz-date-picker formControlName="expiryDateLicence" [nzDisabledDate]="pastDateDisabled"
                                class="w-full"></nz-date-picker>
              </nz-form-control>
              <ng-template #expiryDateLicence>
        <span
          *ngIf="formErrors.passportLicenceDetails.expiryDateLicence.required">Please Enter Licence Expiry Date </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="issuedCountryLicence">Issued Country</nz-form-label>
              <nz-form-control [nzErrorTip]="issuedCountry">
                <nz-select nzAllowClear nzShowSearch (nzOnSearch)="onSearchIssuedCountry($event)" formControlName="issuedCountryLicence"  nzPlaceHolder="Select">
                <nz-option *ngFor="let data of this.filteredIssuedCountryData" nzValue="{{data.name}}" nzLabel="{{data.name}}"></nz-option>

              </nz-select>
              </nz-form-control>
              <ng-template #issuedCountry>
        <span
          *ngIf="formErrors.passportLicenceDetails.issuedCountryLicence.required">Please Enter Licence Issued Country </span>
              </ng-template>
            </nz-form-item>




          </div>

          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-4">

            <div>
              <p class="pb-[8px] font-semibold" style="color:#9A9A9A">Attachments</p>
              <p class="pb-[6px] font-normal">Passport/Licence</p>

              <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                <div>
                  <nz-upload
                    [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false" (cancel)="passportLicenceUploading = false">
                    <button nz-button>
                      <span nz-icon nzType="upload"></span>
                      Click to Upload
                    </button>
                  </nz-upload>
                </div>
                <div>
                  <p *ngIf="passportLicenceUploading" class="text-primary my-2">Uploading...</p>
                </div>
                <div class="mt-2 overflow-auto">
                  <div *ngFor="let file of passportLicenceFiles; let i = index"
                       class="flex justify-between items-center mx-3 gap-5">
                    <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                    <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                          class="cursor-pointer" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this attachment"
                          (nzOnConfirm)="confirmRemoveAttachment(i)"
                    ></span>
                  </div>
                </div>
              </div>


              <!--            <nz-upload [nzCustomRequest]="upload" [nzShowUploadList]="false" [nzMultiple]="false"-->
              <!--                       class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
              <!--              <button nz-button>-->
              <!--                <span nz-icon nzType="upload"></span>-->
              <!--                Click to Upload-->
              <!--              </button>-->
              <!--            </nz-upload>-->
              <!--            <div *ngFor="let file of passportLicenceFiles;let i = index">-->
              <!--              <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
              <!--                                                                                  nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
              <!--                                                                                  nzPopconfirmPlacement="bottom"-->
              <!--                                                                                  (nzOnConfirm)="confirmRemoveAttachment(i)"-->
              <!--                                                                                  (nzOnCancel)="cancel()"nzTheme="outline"></span></a>-->
              <!--            </div>-->
            </div>

          </div>
        </form>
      </div>
    </nz-card>
  </section>


  <section id="buttons" class="mt-6">
    <nz-card>
      <div class="flex justify-end sm:justify-end">
        <a
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="confirm()"
        >
          <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
        </a>
        <button nz-button nzType="primary" *ngIf="this.status === 'create'"
                (click)="onSubmit()" [disabled]="customerForm.invalid">Update Customer
        </button>
        <button nz-button nzType="primary" *ngIf="this.status === 'edit'"
                (click)="onUpdate()" [disabled]="customerForm.invalid">Update Customer
        </button>
      </div>
    </nz-card>
  </section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

